import { ThemeProvider } from "styled-components"
import { UserTheme } from "styles/theme"

import getTheme from "./getTheme"

interface Props {
  readonly children: React.ReactNode
  readonly theme: UserTheme
}

const Provider = ({ children, theme: baseTheme }: Props) => {
  const theme = getTheme(baseTheme)

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default Provider
